import { IUser } from "../../models/user";
import { createSelector, State } from "@ngrx/store";
import { IAppState } from "../states/app";
import { selectAppBootState } from "./boot";
import { state } from "@angular/animations";

export const selectIsAuthenticated = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user.authenticated,
);

export const selectIsAuthenticating = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user.authenticating,
);

export const selectAuthenticatedUser = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user,
);

export const selectAuthenticatedUserRoles = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => (user.me ? user.me.roles : []),
);

// export const selectAuthenticatedUserPermissions = createSelector((state: IAppState) => state.user,
//   (user: IUser) => user.me ? user.me.permissions : []);

export const selectAuthenticatedAdmin = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) =>
    user.me
      ? user.me.permissions.includes("admin") ||
        user.me.permissions.includes("admin-view-dashboard")
      : false,
);

export const selectAuthenticatedUserMe = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user.me,
);

export const authenticationErrors = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user.errors,
);

export const selectRegistrationCompleted = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => (user.me ? user.me.registration_completed : false),
);

export const selectMustReacceptRules = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => (user.me ? user.me.must_reaccept_rules : false),
);

export const selectManageOwnAuctions = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) =>
    user.me ? user.me.permissions.includes("manage-own-auctions") : false,
);

export const selectOtpType = createSelector(
  (state: IAppState) => state.user,
  (user: IUser) => user.otp,
);

export { selectAppBootState };
